module.exports = __webpack_public_path__ + "static/day06-423d521a28241e4507c0f2dc74b495c9.png";